/* eslint-disable */
export default function init(Blockly, profile, img_path) {
  /**
    * Unused constant for the common HSV hue for all blocks in this category.
    * @deprecated Use Blockly.Msg['LISTS_HUE']. (2018 April 5)
    */
  // Blockly.Constants.Lists.HUE = 260;
  // debugger
  Blockly.Blocks.lists = {};
  Blockly.Blocks.lists.num_style = 'num_lists_blocks';
  Blockly.Blocks.lists.text_style = 'text_variables_blocks';
  Blockly.Blocks["LIST_HUE"] = 330;
  Blockly.Blocks["LIST_HUE2"] = 75;

    Blockly.Blocks['lists_length_number'] = {
      /**
       * Block get the lingth of a number type list.
       * @this {Blockly.Block}
       */
      init: function() {
            this.setStyle(Blockly.Blocks.lists.num_style);
            this.setTooltip(Blockly.Msg.LISTS_LENGTH_TOOLTIP);
            this.appendDummyInput("")
                .appendField(Blockly.Msg.LISTS_LENGTH_TITLE)
                .appendField(new Blockly.FieldVariable(Blockly.Msg.LISTS_LISTNAME, null, ['ListNumber'], 'ListNumber'), "VARLISTNUM")
            this.setTooltip(Blockly.Msg.LISTS_LENGTH_TOOLTIP);
            this.setOutput(true, "Number")
        }
    };

    Blockly.Blocks['lists_length_text'] = {
      /**
       * Block get the lingth of a text type list.
       * @this {Blockly.Block}
       */
      init: function() {
          this.setStyle(Blockly.Blocks.lists.text_style);
          this.setTooltip(Blockly.Msg.LISTS_LENGTH_TOOLTIP);
          this.appendDummyInput("")
              .appendField(Blockly.Msg.LISTS_LENGTH_TITLE)
              .appendField(new Blockly.FieldVariable(Blockly.Msg.LISTS_LISTNAME_TEXT, null, ['ListString'], 'ListString'), "VARLISTTEXT")
          this.setTooltip(Blockly.Msg.LISTS_LENGTH_TOOLTIP);
          this.setOutput(true, "Number")
      }
    };

    // overrided by plus minus plugin
    Blockly.Blocks['lists_create_with_number'] = {
    };

    // overrided by plus minus plugin
    Blockly.Blocks['lists_create_with_text'] = {
    };

  Blockly.Blocks['lists_getIndex_number'] = {
    /**
      * Block for getting number element at index.
      * @this {Blockly.Block}
      */
      init: function() {
          this.setStyle(Blockly.Blocks.lists.num_style);
          this.setTooltip(Blockly.Msg.LISTS_GET_INDEX_TOOLTIP);
          this.setOutput(true, "Number");
          this.appendValueInput("AT")
              .setCheck("Number")
              .appendField(new Blockly.FieldVariable(Blockly.Msg.LISTS_LISTNAME, null, ['ListNumber'], 'ListNumber'), "VARLISTNUM")
              .appendField(Blockly.Msg.LISTS_GET_INDEX_GET);
          this.setInputsInline(true)
      }
  };

  Blockly.Blocks['lists_getIndex_text'] = {
    /**
      * Block for getting text element at index.
      * @this {Blockly.Block}
      */
      init: function() {
        this.setStyle(Blockly.Blocks.lists.text_style);
        this.setTooltip(Blockly.Msg.LISTS_GET_INDEX_TOOLTIP);
        this.setOutput(true, "String");
        this.appendValueInput("AT")
            .setCheck("Number")
            .appendField(new Blockly.FieldVariable(Blockly.Msg.LISTS_LISTNAME_TEXT, null, ['ListString'], 'ListString'), "VARLISTTEXT")
            .appendField(Blockly.Msg.LISTS_GET_INDEX_GET);
        this.setInputsInline(true)
    }
  };

  Blockly.Blocks['lists_setIndex_number'] = {
    /**
      * Block for setting the number element at index.
      * @this {Blockly.Block}
      */
      init: function() {
          this.setStyle(Blockly.Blocks.lists.num_style);
          this.setTooltip(Blockly.Msg.LISTS_SET_INDEX_TOOLTIP);
          this.appendValueInput("AT")
              .setCheck("Number")
              .appendField(new Blockly.FieldVariable(Blockly.Msg.LISTS_LISTNAME, null, ['ListNumber'], 'ListNumber'), "VARLISTNUM")
              .appendField(Blockly.Msg.LISTS_SET_INDEX_SET);
          this.appendValueInput("TO")
              .setCheck("Number")
              .appendField("=");
          this.setInputsInline(true);
          this.setPreviousStatement(true);
          this.setNextStatement(true)
      }
  };

  Blockly.Blocks['lists_setIndex_text'] = {
    /**
      * Block for setting the text element at index.
      * @this {Blockly.Block}
      */
      init: function() {
          this.setStyle(Blockly.Blocks.lists.text_style);
          this.setTooltip(Blockly.Msg.LISTS_SET_INDEX_TOOLTIP);
          this.appendValueInput("AT")
              .setCheck("Number")
              .appendField(new Blockly.FieldVariable(Blockly.Msg.LISTS_LISTNAME_TEXT, null, ['ListString'], 'ListString'), "VARLISTTEXT")
              .appendField(Blockly.Msg.LISTS_SET_INDEX_SET);
          this.appendValueInput("TO")
              .setCheck("String")
              .appendField("=");
          this.setInputsInline(true);
          this.setPreviousStatement(true);
          this.setNextStatement(true)
      }
  };
}
